const DisableableField = (props) => {
  const { defaultDisabled, children } = props
  const disabled = defaultDisabled
  return (
    children(disabled)
  )
}

export default DisableableField
